var render = function render(){var _vm=this,_c=_vm._self._c;return _c('div',{staticClass:"flex-col",class:[_vm.widthClass, ...(_vm.zone.class || [])]},_vm._l((_vm.zone.items),function(item,position){return _c('TgpItem',{key:position + '-' + item.id,attrs:{"item":item,"url-config":_vm.urlConfig}})}),1)
}
var staticRenderFns = []

export { render, staticRenderFns }